module.exports = __webpack_public_path__ + "static/media/alt.a2e1c61f.svg";